/**
 * OIDC authentication helpers for the Talos SPA.
 *
 * The gateway exposes /auth/status (unauthenticated) which reports whether OIDC
 * is enabled and whether the current browser has a valid OIDC session cookie.
 * When OIDC is enabled, the API client redirects to /auth/login on 401 when the
 * session expires.
 */

let oidcEnabled = false;

// setOIDCEnabled records whether the server has OIDC auth enabled.
export function setOIDCEnabled(v) {
  oidcEnabled = !!v;
}

// isOIDCEnabled reports whether the server has OIDC auth enabled. When true,
// 401 responses mean "sign in" (the session expired).
export function isOIDCEnabled() {
  return oidcEnabled;
}

// getAuthStatus fetches the current authentication state from the server. It
// resolves with the raw JSON payload ({ authenticated, oidc_enabled, ... }).
export async function getAuthStatus() {
  const resp = await fetch('/auth/status', { credentials: 'same-origin' });
  if (!resp.ok) throw new Error(`auth status failed (${resp.status})`);
  return resp.json();
}

// login redirects to the OIDC authorization endpoint.
export function login() {
  window.location.assign('/auth/login');
}

// logout clears the local session and redirects (to the IdP when configured).
export function logout() {
  window.location.assign('/auth/logout');
}